import { createComponent, createHook } from 'reakit-system';
import invariant from 'tiny-invariant';
import { useField } from '../../Field/Field';
import { useStepperFieldBox } from '../hooks/useStepperBox';
import type { StepperFieldHTMLProps, StepperFieldOptions } from '../types';

export const useStepperFieldInput = createHook<
  StepperFieldOptions,
  StepperFieldHTMLProps
>({
  name: 'StepperFieldInput',
  compose: [useField, useStepperFieldBox],
  useOptions(options) {
    return {
      ...options,
      hasError: false,
      borderRadius: 0,
      py: 'stepperFieldInputPaddingY',
      px: 'stepperFieldInputPaddingX',
      minHeight: undefined,
    };
  },
  useProps(_, props) {
    invariant(
      Number(props.max ?? +Infinity) >= Number(props.min ?? -Infinity),
      'Максимальное значение не должно быть меньше минимального'
    );
    return {
      ...props,
      type: 'number',
    };
  },
});

export const StepperFieldInput = createComponent({
  as: 'input',
  useHook: useStepperFieldInput,
});
